import { useSelector, useDispatch } from 'react-redux';

import * as Types from 'types';
import { Actions } from '../actions';
import { requestUsers } from '../api';

import { LoadQueue } from 'services/LoadQueue';

const loadQueue = new LoadQueue<Types.UserCard>((ids) => {
  return requestUsers({ ids, filter: 'ids' });
});

export const useUserCardLoader = (
  userId?: number,
): Types.UserCard | undefined => {
  const user = useSelector(
    (state: Types.RootState) => state?.users?.byId[userId || 0],
  );

  const dispatch = useDispatch();

  if (!user && userId) {
    if (!loadQueue.receiver) {
      loadQueue.setReceiver((users) => {
        dispatch(Actions.receiveUserCards(users));
      });
    }
    loadQueue.queue([userId]);
  }

  return userId ? user : undefined;
};
